export default "__VITE_ASSET__6tNX20Di__"